import { ScanView } from '@/components/ScanView';
import { useAuthStore } from '@/stores/auth-store';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { toast } from 'sonner';

export const Route = createFileRoute('/_app/staff/scan/attendance')({
  beforeLoad: () => {
    const { user } = useAuthStore.getState();
    if (
      !user ||
      (user.role !== 'ORGANIZER' &&
        user.role !== 'STAFF_ATTENDANCE' &&
        user.role !== 'STAFF_SCANNER')
    ) {
      toast.info('Acceso restringido a staff de asistencia.');
      throw redirect({ to: '/' });
    }
  },
  component: AttendanceScanPage,
});

function AttendanceScanPage() {
  return <ScanView type="ATTENDANCE" title="Escanear asistencia" />;
}
